import { PropsWithChildren, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useOutletContext } from "react-router";
import isFunction from "lodash/isFunction";
import { TAccessCheck } from "components/common/Auth/accessChecks";
import { GenericFallback } from "components/common/ErrorBoundaries";
import { useFeatureFlags } from "context/FeatureFlagsContext";
import { useUser } from "context/UserContext";

type TGuardProps = PropsWithChildren<{
  check: TAccessCheck;
  onDenied?: () => ReactElement | void;
}>;

export const Guard = ({ check, onDenied }: TGuardProps): ReactElement => {
  const { t } = useTranslation("common", { keyPrefix: "messages" });
  const userContext = useUser();
  const featureFlags = useFeatureFlags();
  const parentContext = useOutletContext();

  const isAccessGranted = check({
    featureFlags,
    userContext,
  });

  if (isAccessGranted) {
    return <Outlet context={parentContext} />;
  }

  if (isFunction(onDenied)) {
    return onDenied() ?? <></>;
  }

  return <GenericFallback message={t("genericNoAccess")} />;
};
